import * as React from "react";
import * as Helpers from "../helpers";
import { StepWizardChildProps } from "react-step-wizard";
import { BookingRequestFields } from "./index";
import PageNavigation from "../Components/PageNavigation";
import InputBoolean from "../Components/InputBoolean";
import Steps from "./steps";

export type ReviewFields = {
    review_marketing_consent: string;
    review_gdpr_consent: string;
}

const ReviewBlock: React.FunctionComponent<{ label: string, value: string | undefined }> = (props) => {
    return <div className="review-section">
        <label>{props.label}</label>
        <div>{props.value}</div>
    </div>
};

export class Review extends React.Component<PageProps<BookingRequestFields> & Partial<StepWizardChildProps>, PageSubmitState>{
    constructor(props: PageProps<BookingRequestFields>) {
        super(props);

        this.state = {
            validation_triggered: false,
            is_submitting: false
        };
    }

    triggerValidation()
    {
        const page_fields = [ "review_marketing_consent", "review_gdpr_consent" ];
        return Helpers.TriggerValidation(this, page_fields, this.props.required, this.props.form_values);
    }

    goToEdit(step: number) {
        if (this.props.goToStep) {
            this.props.goToStep(step);
        }
    }

    goBack() {
        if (this.props.previousStep) {
            this.props.previousStep();
        }
    }

    submit() {
        const validation_result = this.triggerValidation();
        if (!validation_result) {
            return;
        }

        this.setState(() => {
            return { is_submitting: true };
        });

        const url = location.pathname;
        const body = new FormData();
        for (const value in this.props.form_values) {
            // @ts-ignore
            body.append(value, this.props.form_values[value] as string);
        }

        fetch(url, {
            method: "POST",
            body: body
        })
            .then(async (response) => {
                const result = await response.json() as FormResponse;
                this.props.update_success(result.success, result.errors);
            })
            .catch(() => {
                this.props.update_success(false);
            })
            .finally(() => {
                Helpers.PushDataLayerEvent({
                    event: "form_submission",
                    form_name: "booking_request_landing"
                })
                if (this.props.nextStep) {
                    this.props.nextStep();
                }
            });
    }
    render() {
        let scrolled = false;
        let getScrolled = () => scrolled;
        let setScrolled = () => { scrolled = true; };

        return <div>
            <div className="row">
                <div className="col-md-6">
                    <div className="landing-review-block-wrapper">
                        <h4>1. Your Schedule <button onClick={() => this.goToEdit(2)}  className="landing-review-edit"><i className="fa fa-edit"></i></button></h4>
                        <div className="landing-review-block">
                            <ReviewBlock
                                label="How often would you like a cleaner?"
                                value={this.props.form_values.schedule_frequency}
                            />
                            {this.props.form_values.schedule_frequency === "Other" ?
                                <ReviewBlock
                                    label="Please provide details about the clean you require"
                                    value={this.props.form_values.schedule_frequency_other}
                                />
                                : null}
                            <ReviewBlock
                                label="How long do you need a cleaner?"
                                value={this.props.form_values.schedule_time_required}
                            />
                            <ReviewBlock
                                label="Preferred day"
                                value={this.props.form_values.schedule_cleaner_day}
                            />
                            {this.props.form_values.schedule_cleaner_day === "Fri" ?
                                <ReviewBlock
                                    label="Back up day"
                                    value={this.props.form_values.schedule_cleaner_backup}
                                />
                                : null}
                            <ReviewBlock
                                label="Preferred time(s)"
                                value={this.props.form_values.schedule_cleaner_time}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="landing-review-block-wrapper">
                        <h4>2. Home Details <button onClick={() => this.goToEdit(3)}  className="landing-review-edit"><i className="fa fa-edit"></i></button></h4>
                        <div className="landing-review-block">
                            <ReviewBlock
                                label="Number of Bedrooms"
                                value={this.props.form_values.home_bedrooms}
                            />
                            <ReviewBlock
                                label="Number of Bathrooms"
                                value={this.props.form_values.home_bathrooms}
                            />
                            <ReviewBlock
                                label="Do you have pets?"
                                value={(this.props.form_values.home_pets === "true" ? "Yes" : "No")}
                            />
                            {this.props.form_values.home_pets === "true" ?
                                <ReviewBlock
                                    label="Please state what pets you have"
                                    value={this.props.form_values.home_pets_details}
                                />
                                : null}
                        </div>
                    </div>
                    <div className="landing-review-block-wrapper">
                        <h4>3. Services <button onClick={() => this.goToEdit(4)}  className="landing-review-edit"><i className="fa fa-edit"></i></button></h4>
                        <div className="landing-review-block">
                            <ReviewBlock
                                label="Services Required?"
                                value={this.props.form_values.services_required?.replace(",", ", ")}
                            />
                            {this.props.form_values.services_required && this.props.form_values.services_required.includes("Other") ?
                                <ReviewBlock
                                    label="Please provide details about the clean you require"
                                    value={this.props.form_values.services_required_other}
                                />
                                : null}
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <div className="landing-review-block-wrapper">
                        <h4>4. Contact Details <button onClick={() => this.goToEdit(1)}  className="landing-review-edit"><i className="fa fa-edit"></i></button></h4>
                        <div className="landing-review-block">
                            <ReviewBlock
                                label="First Name"
                                value={this.props.form_values.contact_first_name}
                            />
                            <ReviewBlock
                                label="Last Name"
                                value={this.props.form_values.contact_last_name}
                            />
                            <ReviewBlock
                                label="Phone"
                                value={this.props.form_values.contact_phone}
                            />
                            <ReviewBlock
                                label="Email"
                                value={this.props.form_values.contact_email}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="landing-review-block-wrapper">
                        <h4>5. Address <button onClick={() => this.goToEdit(5)}  className="landing-review-edit"><i className="fa fa-edit"></i></button></h4>
                        <div className="landing-review-block">
                            <ReviewBlock
                                label="Address Line 1"
                                value={this.props.form_values.address_line_1}
                            />
                            <ReviewBlock
                                label="Address Line 2"
                                value={this.props.form_values.address_line_2}
                            />
                            <ReviewBlock
                                label="Town / City"
                                value={this.props.form_values.address_town}
                            />
                            <ReviewBlock
                                label="County"
                                value={this.props.form_values.address_county}
                            />
                            <ReviewBlock
                                label="Postcode"
                                value={this.props.form_values.address_postcode}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <div className="landing-review-block-wrapper">
                        <h4>5. Marketing / Promotions <button onClick={() => this.goToEdit(6)}  className="landing-review-edit"><i className="fa fa-edit"></i></button></h4>
                        <div className="landing-review-block">
                            <ReviewBlock
                                label="How did you hear about us?"
                                value={this.props.form_values.address_source}
                            />
                            {this.props.form_values.address_source === "Other" ?
                                <ReviewBlock
                                    label="Please specify"
                                    value={this.props.form_values.address_source_other}
                                />
                                : null}
                            <ReviewBlock
                                label="Voucher Code"
                                value={this.props.form_values.address_voucher}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                </div>
            </div>

            <InputBoolean
                label="If you'd like to hear from us and our franchisees about special offers and promotions, please check this box"
                name="review_marketing_consent"
                use_checkbox={true}
                value={this.props.form_values.review_marketing_consent}
                required={this.props.required.review_marketing_consent}
                validation_triggered={this.state.validation_triggered}
                validation_get_scrolled={getScrolled}
                validation_set_scrolled={setScrolled}
                update_value={this.props.update_value}
            />

            <InputBoolean
                label={<>I accept that my information will be dealt with in accordance to the Time For You <a href="/uk/privacy.aspx" target="_blank">Privacy Policy</a></>}
                name="review_gdpr_consent"
                use_checkbox={true}
                value={this.props.form_values.review_gdpr_consent}
                required={this.props.required.review_gdpr_consent}
                show_only_yes={true}
                validation_triggered={this.state.validation_triggered}
                validation_get_scrolled={getScrolled}
                validation_set_scrolled={setScrolled}
                update_value={this.props.update_value}
            />

            <div className="row">
                <div className="col-md-6">
                    <Steps totalSteps={this.props.totalSteps!} currentStep={this.props.currentStep!} />
                </div>
                <div className="col-md-6">
                    <PageNavigation allowPrevious={true} allowNext={true} useSubmitForNext={true} onNext={() => this.submit()} onPrevious={() => this.goBack()} />
                </div>
            </div>
        </div>
    }
}